import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";

am4core.useTheme(am4themes_animated);

import {find_evaluation, evaluation} from '../config/evaluations'


export const generateBarLineChart = (graphs) => {
    var chart = am4core.create(graphs.id, am4charts.XYChart);
   // chart.colors.list = colors_palette.map(function(c){return am4core.color(c)});

    chart.colors.step = 1;
    chart.maskBullets = false;

    if (graphs.locale == "it")
	chart.language.locale = am4lang_it_IT;
    var title = chart.titles.create();

    if(graphs.title != null){
	title.text = graphs.title;
	title.fontSize = 25;
	title.marginBottom = 30;
    }
    chart.data = graphs.data;

    var categoryAxis = (graphs.horizontal ? chart.yAxes : chart.xAxes).push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.minGridDistance = 1;
    if(graphs.bar.length > 0)
	categoryAxis.renderer.grid.template.location = 0;

    categoryAxis.cursorTooltipEnabled = false;
    var barAxis = (graphs.horizontal ? chart.xAxes : chart.yAxes).push(new am4charts.ValueAxis());
    barAxis.cursorTooltipEnabled = false;

    if(graphs.bar_axis_unit)
	barAxis.renderer.labels.template.adapter.add("textOutput", function(text, target) {
	    return text+" "+graphs.bar_axis_unit;
	});

    var lineAxis = (graphs.horizontal ? chart.xAxes : chart.yAxes).push(new am4charts.ValueAxis());
    lineAxis.cursorTooltipEnabled = false;
    lineAxis.renderer.grid.template.disabled = (graphs.bar.length > 0);
    if((Array.isArray(graphs.bar) && graphs.bar.length > 0) || (graphs.line != null && graphs.line.filter(function(l){ return l.axis == 'bar'}).length > 0))
	lineAxis.renderer.opposite = true;
    else{
	lineAxis.renderer.gridContainer.background.fill = "#ffffff"
	lineAxis.renderer.gridContainer.background.fillOpacity = 0.6;
	title.marginBottom = 10;
	chart.scrollbarY = new am4core.Scrollbar();
    }
    if(graphs.line_axis_unit)
	lineAxis.renderer.labels.template.adapter.add("textOutput", function(text, target) {
	    return text+" "+graphs.line_axis_unit;
	});
    if(Array.isArray(graphs.bar))
	graphs.bar.forEach(function(e) {
	    var barSeries = chart.series.push(new am4charts.ColumnSeries());

	    if(graphs.horizontal){
		barSeries.dataFields.valueX = e.field;
		barSeries.dataFields.categoryY = "category";
		barSeries.xAxis = barAxis;
		// barSeries.tooltipText = "{valueX.formatNumber('#,###.##')}";
		categoryAxis.renderer.minGridDistance = 20;
	    }
	    else{
		barSeries.dataFields.valueY = e.field;
		barSeries.dataFields.categoryX = "category";
		barSeries.yAxis = barAxis;
		barSeries.tooltipText = "{valueY.formatNumber('#,###.##')}";
	    }

	    if(e.unit)
		barSeries.tooltipText += " "+e.unit;
	    barSeries.name = e.title;
	    barSeries.columns.template.fillOpacity = 0.7;
	    barSeries.hoverOnFocus = true;
	    barSeries.columns.template.propertyFields.strokeDasharray = "dashLength";
	    barSeries.columns.template.propertyFields.fillOpacity = "alpha";


	    if(e.colors)
		barSeries.columns.template.adapter.add("fill", function(fill, target) {
		    return e.colors[target.dataItem.index];
		});

	    if(e.border_colors){
		barSeries.columns.template.adapter.add("stroke", function(stroke, target) {
		    return e.border_colors[target.dataItem.index];
		});
		barAxis.renderer.gridContainer.background.fill = "#ffffff"
		barAxis.renderer.gridContainer.background.fillOpacity = 0.6;
		categoryAxis.renderer.grid.template.disabled = true;
		title.marginBottom = 10;
		barSeries.columns.template.adapter.add('tooltipText', function(text, target) {
		    var val = target.tooltipDataItem.dataContext;
		    if(val.rating)
			return val.category+": "+val.rating;
		    else
			return "{valueX.formatNumber('#,###.##')}"
		});
		if(graphs.label && graphs.label.vals){
		    barAxis.min = 0;
		    barAxis.max = 100;
		    barAxis.strictMinMax = true;
		    chart.data = graphs.data;
		    barAxis.renderer.labels.template.adapter.add("textOutput", function(text, target) {
			barAxis.renderer.minGridDistance = 20;
			
			barAxis.renderer.labels.template.horizontalCenter = "left";
			barAxis.renderer.labels.template.paddingLeft = 20;
			if (text)
			    return graphs.label.vals[parseInt(text.substring(0, text.length-1))];
		    });
		}
	    }
	    var disatnceState = barSeries.columns.template.states.create("hover");
	    disatnceState.properties.fillOpacity = 0.9;
	});

    if(Array.isArray(graphs.line))
	graphs.line.forEach(function(e) {
	    var lineSeries = chart.series.push(new am4charts.LineSeries());
	    if(graphs.horizontal){
		lineSeries.dataFields.valueX = e.field;
		lineSeries.dataFields.categoryY = "category";
		lineSeries.yAxis = e.axis == 'bar' ? barAxis : lineAxis;
	    }
	    else{
		lineSeries.dataFields.valueY = e.field;
		lineSeries.dataFields.categoryX =  "category";
		lineSeries.yAxis = e.axis == 'bar' ? barAxis : lineAxis;
	    }
	    //	lineSeries.fillOpacity = 0.3;
	    lineSeries.name = e.title;
	    lineSeries.strokeWidth = 2;
	    lineSeries.propertyFields.strokeDasharray = "dashLength";
	    lineSeries.cursorTooltipEnabled = false;
	    if(e.color)
		lineSeries.stroke= am4core.color(e.color)
	    //	lineSeries.tooltipText = "{valueY.formatNumber('#,###.##')}";
	    //	if(e.unit)
	    //	    lineSeries.tooltipText += " "+e.unit;
	    if(e.bullet == 'rectangle'){
		var bullect = lineSeries.bullets.push(new am4charts.Bullet());
		var rectangle = bullect.createChild(am4core.Rectangle);
		bullect.horizontalCenter = "middle";
		bullect.verticalCenter = "middle";

		bullect.width = 7;
		bullect.height = 7;
		rectangle.width = 7;
		rectangle.height = 7;
	    }
	    else{
		var bullect = lineSeries.bullets.push(new am4charts.CircleBullet());
		bullect.circle.fill = am4core.color("#fff");
		bullect.circle.strokeWidth = 2;
		
	    }
	    if(e.lineCircleColor)
		bullect.circle.adapter.add("fill", function(fill, target) {
		    
		    if(target.dataItem.dataContext && target.dataItem.dataContext[e.field])
			return e.lineCircleColor(target.dataItem.dataContext[e.field])
		    else
			return '#fff'
		    
		    
		})
	    
	    if(graphs.horizontal)
		bullect.tooltipText = "{valueX.formatNumber('#,###.##')}"
	    else
		bullect.tooltipText = "{valueY.formatNumber('#,###.##')}"
	    if(e.unit)
	    	bullect.tooltipText += e.unit;

	    var state = bullect.states.create("hover");
	    state.properties.scale = 1.2;
	})

    if(!graphs.hide_legend === true)
	chart.legend = new am4charts.Legend();

    chart.cursor = new am4charts.XYCursor();
    chart.cursor.fullWidthLineX = false;
    // chart.cursor.yAxis = categoryAxis;
    chart.cursor.lineX.strokeOpacity = 0;
    chart.cursor.lineX.fill = am4core.color("#000");
    chart.cursor.lineX.fillOpacity = 0.1;
    chart.cursor.behavior = "zoomXY";

    return chart;
}

export const divergentStackedBars = ({name, title, data, names, reversed=false}) => {
    var chart = am4core.create(name, am4charts.XYChart);
 
    chart.language.locale = am4lang_it_IT;
    
    // Title
    var titleChart = chart.titles.push(new am4core.Label());
    titleChart.text = title;
    titleChart.fontSize = 25;
    titleChart.marginBottom = 15;

    // Add data
    chart.data = data


    // Create axes
    var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.opposite = reversed;
    categoryAxis.renderer.minGridDistance = 20;
    categoryAxis.renderer.axisFills.template.disabled = false;
    categoryAxis.renderer.axisFills.template.fillOpacity = 0.05;


    var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    
    valueAxis.renderer.inversed = reversed;
   /* valueAxis.renderer.minGridDistance = 50;
    valueAxis.renderer.ticks.template.length = 5;
    valueAxis.renderer.ticks.template.disabled = false;
    valueAxis.renderer.ticks.template.strokeOpacity = 0.4;
  */

    // Use only absolute numbers
    chart.numberFormatter.numberFormat = "#,###";

    // Create series
    function createSeries(field, name, color, xAxis) {
	var series = chart.series.push(new am4charts.ColumnSeries());
	
	series.dataFields.valueX = field;
	series.dataFields.categoryY = "category";
	series.stacked = true;
//	series.clustered = false;
	series.name = name;
	series.stroke = color;
	series.fill = color;
	var label = series.bullets.push(new am4charts.LabelBullet);
	label.label.text = "{valueX}";
	label.label.fill = am4core.color("#fff");
	label.label.strokeWidth = 0;
	label.label.truncate = false;
	label.label.hideOversized = true;
	label.locationX = 0.5;
	return series;
    }

    var interfaceColors = new am4core.InterfaceColorSet();
    var positiveColor = interfaceColors.getFor("positive");
    var negativeColor = interfaceColors.getFor("negative");
  
    createSeries(names.value2, "Expired", negativeColor);
    createSeries(names.value1, "Opened", positiveColor);

}

export const gaugeChart = ({name, ratio}) => {
    var chart = am4core.create(name, am4charts.GaugeChart);
    chart.innerRadius = am4core.percent(82);

    /**
     * Normal axis
     */

    var axis = chart.xAxes.push(new am4charts.ValueAxis());
    axis.min = 0;
    axis.max = 100;
    axis.strictMinMax = true;
    axis.renderer.radius = am4core.percent(80);
    axis.renderer.inside = true;
    axis.renderer.line.strokeOpacity = 1;
    axis.renderer.ticks.template.disabled = false
    axis.renderer.ticks.template.strokeOpacity = 1;
    axis.renderer.ticks.template.length = 10;
    axis.renderer.grid.template.disabled = true;
    axis.renderer.labels.template.radius = 40;
    axis.renderer.labels.template.adapter.add("text", function(text) {
	return text + "%";
    })

    /**
     * Axis for ranges

     */
    var interfaceColors = new am4core.InterfaceColorSet();
    var axis2 = chart.xAxes.push(new am4charts.ValueAxis());
    axis2.min = 0;
    axis2.max = 100;
    axis2.strictMinMax = true;
    axis2.renderer.labels.template.disabled = true;
    axis2.renderer.ticks.template.disabled = true;
    axis2.renderer.grid.template.disabled = true;

    var range0 = axis2.axisRanges.create();
    range0.value = 0;
    range0.endValue = ratio*100;
    range0.axisFill.fillOpacity = 1;
    range0.axisFill.fill = interfaceColors.getFor("negative");

    var range1 = axis2.axisRanges.create();
    range1.value = ratio*100;
    range1.endValue = 100;
    range1.axisFill.fillOpacity = 1;
    range1.axisFill.fill = interfaceColors.getFor("positive");

    /**
     * Label
     */

    var label = chart.radarContainer.createChild(am4core.Label);
    label.isMeasured = false;
    label.fontSize = 45;
    label.x = am4core.percent(50);
    label.y = am4core.percent(100);
    label.horizontalCenter = "middle";
    label.verticalCenter = "bottom";
    label.text = Math.round(ratio*100).toFixed(0)+"%";


    /**
     * Hand
     */

    var hand = chart.hands.push(new am4charts.ClockHand());
    hand.axis = axis2;
    hand.innerRadius = am4core.percent(20);
    hand.startWidth = 10;
    hand.pin.disabled = true;
    hand.value = ratio*100;



    
}


export const gaugeChartScore = ({score, name, title}) => {
 
    var chartMin = 0;
    var chartMax = 10;

    var data = {
	score: score,
	gradingData: [
	 
	    {
		title: "Risk",
		color: "#cc0000",
		lowScore: -1,
		highScore: 4
	    },
	    {
		title: "Equilibrated",
		color: "#ff9900",
		lowScore: 4,
		highScore: 6
	    },
	    {
		title: "Healthy",
		color: "#2E7D32",
		lowScore: 6,
		highScore: 10
	    }
	]
    };


    function lookUpGrade(lookupScore, grades) {
	// Only change code below this line
	for (var i = 0; i < grades.length; i++) {
	    if (
		grades[i].lowScore < lookupScore &&
		    grades[i].highScore >= lookupScore
	    ) {
		return grades[i];
	    }
	}
	return null;
    }

    // create chart
    var chart = am4core.create(name, am4charts.GaugeChart);
    
    chart.hiddenState.properties.opacity = 0;
    chart.fontSize = 11;
    chart.innerRadius = am4core.percent(70);
    chart.resizable = true;

     
    

    if(title != null){
	var titleG = chart.titles.create();
	titleG.text = title;
	titleG.fontSize = 15;
	titleG.marginBottom = 0;
    }
    
    var axis2 = chart.xAxes.push(new am4charts.ValueAxis());
    axis2.min = chartMin;
    axis2.max = chartMax;
    axis2.strictMinMax = true;
    axis2.renderer.labels.template.disabled = true;
    axis2.renderer.ticks.template.disabled = true;
    axis2.renderer.grid.template.disabled = false;
    axis2.renderer.grid.template.opacity = 0.5;
    axis2.renderer.labels.template.bent = true;
    axis2.renderer.labels.template.fill = am4core.color("#000");
    axis2.renderer.labels.template.fontWeight = "bold";
    axis2.renderer.labels.template.fillOpacity = 0.7;


    for (let grading of data.gradingData) {
	var range = axis2.axisRanges.create();
	range.axisFill.fill = am4core.color(grading.color);
	range.axisFill.fillOpacity = 0.8;
	range.axisFill.zIndex = -1;
	range.value = grading.lowScore > chartMin ? grading.lowScore : chartMin;
	range.endValue = grading.highScore < chartMax ? grading.highScore : chartMax;
	range.grid.strokeOpacity = 0;
	range.stroke = am4core.color(grading.color).lighten(-0.1);
	range.label.inside = true;
	range.label.text = grading.title.toUpperCase();
	range.label.inside = true;
	range.label.location = 0.5;
	range.label.inside = true;
	range.label.radius = am4core.percent(10);
	range.label.paddingBottom = -5; // ~half font size
	range.label.fontSize = "0.9em";
    }

    var matchingGrade = lookUpGrade(data.score, data.gradingData);

    /**
     * Label 1
     */

    var label = chart.radarContainer.createChild(am4core.Label);
    label.isMeasured = false;
    label.fontSize = "6em";
    label.x = am4core.percent(50);
    label.paddingBottom = 15;
    label.horizontalCenter = "middle";
    label.verticalCenter = "bottom";
   
    label.text = find_evaluation({score: data.score}).letter;
    
    label.fill = am4core.color(matchingGrade.color);

    /**
     * Label 2
     */

    var label2 = chart.radarContainer.createChild(am4core.Label);
    label2.isMeasured = false;
    label2.fontSize = "2em";
    label2.horizontalCenter = "middle";
    label2.verticalCenter = "bottom";
    label2.text = matchingGrade.title.toUpperCase();
    label2.fill = am4core.color(matchingGrade.color);


    /**
     * Hand
     */

    var hand = chart.hands.push(new am4charts.ClockHand());
    hand.axis = axis2;
    hand.innerRadius = am4core.percent(55);
    hand.startWidth = 8;
    hand.pin.disabled = true;
    hand.value = data.score;
    hand.fill = am4core.color("#444");
    hand.stroke = am4core.color("#000");


 
}
